export const HISTORICALDATA = {
  CLIENT_TYPE_INTERNAL_MOBILE: 'INTERNAL_MOBILE',
  HOURS_AGO: 8,
  MAX_MINUTES: 15,
} as const;
